import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { SkillApiService } from './apis/skill-api';
import { SkillApiServiceImpl } from './apis/impls/skill-api';
import { McpApiService } from './apis/mcp-api';
import { McpApiServiceImpl } from './apis/impls/mcp-api';
import { CustomizeService } from './services/customize-service';
import { CustomizeServiceImpl } from './services/impls/customize-service';

export const customizeContainer = new ContainerModule(bind => {
    bind(SkillApiService).to(SkillApiServiceImpl);
    bind(McpApiService).to(McpApiServiceImpl);
    bind(CustomizeService).to(CustomizeServiceImpl);
});
